import styled from 'styled-components';
import { WarningFill } from 'ui/icons/status/WarningFill';
import { useContentErrors } from '../../../../hooks/form';

const Wrapper = styled.div`
  color: #d14233;
  svg {
    vertical-align: middle;
    margin-top: -${({ theme }) => theme.spacing.values.eighth};
  }
`;

export const ErrorMessage = () => {
  const errors = useContentErrors();
  return (
    <Wrapper data-test="error-message">
      <WarningFill isColorInherited /> {errors?.message}
    </Wrapper>
  );
};
